// @flow
import React from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoute } from 'utils/routing'

import ImportLogs from 'components/Imports/ImportLogs/index';
import ChooseImportType from 'components/Imports/ChooseImportType';
import CSVImport from 'components/Imports/NewImports/CSVImport';

const ImportsLayout = () => (
  <Switch>
    <PrivateRoute requiredGate="ACCOUNTS_IMPORT" exact path="/imports/new/csv" component={CSVImport} />
    <PrivateRoute requiredGate="ACCOUNTS_IMPORT" exact path="/imports/new" component={ChooseImportType} />
    <PrivateRoute requiredGate="ACCOUNTS_IMPORT" path="/imports/:type?" component={ImportLogs} />
  </Switch>
)

export default ImportsLayout
